// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/styles/icon.css'
import '@/assets/styles/reset.css'
import { Lazyload } from 'vant';
import '@/assets/styles/iconfont/iconfont.css'
import vueMiniPlayer from 'vue-mini-player'
import 'vue-mini-player/lib/vue-mini-player.css'
import axios from 'axios'
import * as echarts from 'echarts'
import { getConfigData } from '@/utils/serverConfig';
import preventRepeatClick from '@/utils/preventRepeatClick';
import '@/utils/rem.js';
import VueCookies from 'vue-cookies';
import waterfall from 'vue-waterfall2';



Vue.prototype.$echarts = echarts
//其他vue组件中就可以this.$axios调用使用
Vue.prototype.$axios = axios
axios.defaults.baseURL= getConfigData();
Vue.use(Lazyload);
Vue.use(Vant);
Vue.use(vueMiniPlayer);
Vue.use(preventRepeatClick);
Vue.use(VueCookies);
Vue.use(waterfall);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({

  data: function(){
    return {
      localhostIp:getConfigData(),
    }
  },
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js